module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-6-4c2b5fec46f4ffcf8b22d42cee1d5265.png";